export default "__VITE_ASSET__Btrxew0p__"